import React from 'react'
import { Snackbar, Alert } from '@mui/material';
import { useThemeContext } from '../../Context/ThemeContext';
import { DARKCOLORS, LIGHTCOLORS } from '../../Utils/constants';

function SuccessNotification({ open, message, severity = 'success', onClose }) {
    const { mode } = useThemeContext();

    const inputBoxColor = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
    const inputBoxColor1 = mode === 'dark' ? DARKCOLORS.GreyScale30 : LIGHTCOLORS.GreyScale30;

    return (
        <Snackbar
            open={open}
            autoHideDuration={4000} // 4 seconds
            onClose={onClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert onClose={onClose} severity={severity} sx={{
                width: '100%',
                backgroundColor: inputBoxColor,
                borderRadius: "50px",
                padding: "10px 25px",
                border: `1px solid ${inputBoxColor1}`
            }}>
                {message}
            </Alert>
        </Snackbar>
    );
}

export default SuccessNotification